import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import PenaltyAccepted from "./penalty-accepted";

export default class KickOffPenaltyAccepted extends PenaltyAccepted {
    summarize(summaryContext, stringifier) {
        const message = `by ${stringifier.firstInitial(
            this.causedBy
        )}, ${stringifier.gain(
            Object.assign(summaryContext, {
                homeTeamHasPossession:
                    summaryContext?.kickedBy?.teamId ===
                    summaryContext?.homeTeamId
            }),
            summaryContext.fieldPosition,
            this.fieldPosition
        )} Accepted`;

        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.homeTeamHasPossession =
            summaryContext?.kickedBy?.teamId === summaryContext.homeTeamId;
        summaryContext.fieldPosition = this.fieldPosition;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            causedBy: playerReducer(this.causedBy)
        };
    }
}
